import { FormlyFieldConfig } from '@ngx-formly/core';

// expName. Example: 'hide' or 'disabledProp'
export function getExpressionsInputForm(expName: string): FormlyFieldConfig {
  return {
    wrappers: ['category'],
    key: `expressions.${expName}Raw`,
    props: {
      label: `formGenerator.uiElement.expressionsProp.${expName}Exp.title`,
      info: `formGenerator.uiElement.expressionsProp.${expName}Exp.info`,
      translate: true,
    },
    fieldGroup: [
      {
        className: 'form-wrapper--row',
        fieldGroup: [
          {
            key: 'modelType',
            type: 'select',
            hide: true,
            defaultValue: 'GLOBAL',
            props: {
              options: [
                {
                  id: 'GLOBAL',
                  name: 'Global path',
                },
                {
                  id: 'LOCAL',
                  name: 'Local',
                },
              ],
              valueProp: 'id',
              labelProp: 'name',
              required: false,
            },
          },
          {
            key: 'setting',
            type: 'select',
            defaultValue: 'NEVER',
            props: {
              label: 'Setting',
              options: [
                {
                  id: 'NEVER',
                  name: 'Never',
                },
                {
                  id: 'ALWAYS',
                  name: 'Always',
                },
                {
                  id: 'ONLYIF',
                  name: 'Only if',
                },
                {
                  id: 'ONLYIFNOT',
                  name: 'Only if not',
                },
              ],
              valueProp: 'id',
              labelProp: 'name',
              required: false,
            },
          },
          {
            key: 'joinCondition',
            type: 'select',
            defaultValue: 'AND',
            expressions: {
              hideRaw: {
                modelType: 'LOCAL',
                setting: 'ONLYIF',
                joinCondition: 'OR',
                expressionConditions: [
                  {
                    expressionCheck: {
                      operandLeftType: 'PATH',
                      operator: 'INLIST',
                      operandRightType: 'VALUE',
                      operandLeftValue: 'setting',
                      operandRightValue: 'NEVER,ALWAYS',
                    },
                  },
                ],
              },
            },
            props: {
              translate: true,
              label: 'formGenerator.uiElement.expressionsProp.joinCondition',
              options: [
                {
                  id: 'AND',
                  name: 'AND',
                },
                {
                  id: 'OR',
                  name: 'OR',
                },
              ],
              valueProp: 'id',
              labelProp: 'name',
              required: false,
            },
          },
        ],
      },
      {
        className: 'form-wrapper--row',
        fieldGroup: [
          {
            className: 'form-wrapper--fieldset',
            wrappers: ['fieldset'],
            expressions: {
              hideRaw: {
                modelType: 'LOCAL',
                setting: 'ONLYIF',
                joinCondition: 'OR',
                expressionConditions: [
                  {
                    expressionCheck: {
                      operandLeftType: 'PATH',
                      operator: 'NOTINLIST',
                      operandRightType: 'VALUE',
                      operandLeftValue: 'setting',
                      operandRightValue: 'ONLYIF,ONLYIFNOT',
                    },
                  },
                ],
              },
            },
            props: {
              translate: true,
              label: 'formGenerator.uiElement.expressionsProp.conditions',
            },
            fieldGroup: [
              {
                key: 'expressionConditions', // .expressionCheck
                className: 'form-wrapper--row',
                type: 'fields-array',
                fieldArray: {
                  fieldGroup: [
                    {
                      wrappers: ['row'],
                      className: 'form-wrapper--row',
                      fieldGroup: [
                        {
                          key: 'expressionCheck.operandLeftType',
                          type: 'select',
                          hide: true,
                          defaultValue: 'PATH',
                          props: {
                            translate: true,
                            label:
                              'formGenerator.uiElement.expressionsProp.operandLeftType',
                            options: [
                              {
                                id: 'PATH',
                                name: 'Global path',
                              },
                              /*{
                                id: 'LOCALPATH',
                                name: 'Local path',
                              },*/
                              {
                                id: 'VALUE',
                                name: 'Value',
                              },
                            ],
                            valueProp: 'id',
                            labelProp: 'name',
                            required: false,
                          },
                        },
                        {
                          key: 'expressionCheck.operandLeftValue',
                          type: 'input',
                          props: {
                            translate: true,
                            label:
                              'formGenerator.uiElement.expressionsProp.operandLeftValue',
                            required: false,
                          },
                        },
                        {
                          key: 'expressionCheck.operator',
                          type: 'select',
                          defaultValue: 'EQUALS',
                          props: {
                            translate: true,
                            label:
                              'formGenerator.uiElement.expressionsProp.operator',
                            options: [
                              {
                                id: 'EQUALS',
                                name: 'Equals',
                              },
                              {
                                id: 'NOTEQUALS',
                                name: 'Different',
                              },
                              {
                                id: 'INLIST',
                                name: 'In list',
                              },
                              {
                                id: 'NOTINLIST',
                                name: 'Not in list',
                              },
                              {
                                id: 'CONTAINSTEXT',
                                name: 'Contains text',
                              },
                            ],
                            valueProp: 'id',
                            labelProp: 'name',
                            required: false,
                          },
                        },
                        {
                          key: 'expressionCheck.operandRightType',
                          type: 'select',
                          hide: true,
                          defaultValue: 'VALUE',
                          props: {
                            translate: true,
                            label:
                              'formGenerator.uiElement.expressionsProp.operandRightType',
                            options: [
                              {
                                id: 'PATH',
                                name: 'Global path',
                              },
                              /*{
                                id: 'LOCALPATH',
                                name: 'Local path',
                              },*/
                              {
                                id: 'VALUE',
                                name: 'Value',
                              },
                            ],
                            valueProp: 'id',
                            labelProp: 'name',
                            required: false,
                          },
                        },
                        {
                          key: 'expressionCheck.operandRightValue',
                          type: 'input',
                          props: {
                            translate: true,
                            label:
                              'formGenerator.uiElement.expressionsProp.operandRightValue',
                            required: false,
                          },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    ],
  } as unknown as FormlyFieldConfig;
}
export const expressionsInputForm: FormlyFieldConfig[] = [
  {
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        key: '',
        className: 'form-wrapper--fieldset',
        wrappers: ['fieldset'],
        props: {
          translate: true,
          label: 'formGenerator.uiElement.expressionsProp.titleFieldset',
        },
        fieldGroup: [
          {
            className: 'form-wrapper--row',
            fieldGroup: [getExpressionsInputForm('requiredProp')],
          },
          {
            className: 'form-wrapper--row',
            fieldGroup: [getExpressionsInputForm('hide')],
          },
          {
            className: 'form-wrapper--row',
            fieldGroup: [getExpressionsInputForm('disabledProp')],
          },
        ],
      },
    ],
  },
];
